














































import { Component, Vue, Prop } from 'vue-property-decorator';

import CheckIcon from '@/components/icons/Check.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import { IOfferDiscountTypeName, SpecialOfferTypeEnum } from '@/models/offer';
import TagSpecialCoin from '@/componentsV2/atoms/TagSpecialCoin/TagSpecialCoin.vue';
import TagBirthday from '@/components/organisms/Offers/DataPresentation/TagBirthday.vue';
import { formatMoney } from '@/utils/moneyFormarter';

@Component({
  components: {
    Typography,
    CheckIcon,
    TagSpecialCoin,
    TagBirthday
  }
})
export default class DiscountOffer extends Vue {
  @Prop() offer!: any;
  @Prop({ default: 'big' }) variant!: 'big' | 'medium';

  SpecialOfferTypeEnum = SpecialOfferTypeEnum;

  get placeholderTag() {
    return 'ONE TIME';
  }

  get country() {
    return this.$store.getters['internationalization/getCountrySettings'];
  }

  get isBirthday() {
    return this.offer.specialType === SpecialOfferTypeEnum.BIRTHDAY;
  }

  get specialType() {
    return this.offer.specialType;
  }

  getFormatedDiscount(
    typeDiscount: string,
    value: string,
    isDiscount?: boolean
  ) {
    if (value === 'Free') return value;
    else if (!value) return 'Price Here';

    if (typeDiscount === IOfferDiscountTypeName.PERCENTAGE) {
      return `${value}% OFF`;
    }
    return `${formatMoney(
      this.country,
      String(value).replace(/[^0-9.-]+/g, '')
    )} ${isDiscount ? 'OFF' : ''}`;
  }

  calcDiscount(
    typeDiscount: string,
    valueOfferStr: string,
    valueDiscountStr: string
  ) {
    let res: number;
    const valueOffer: number = Number(
      String(valueOfferStr).replace(/[^0-9.-]+/g, '')
    );
    const valueDiscount: number = Number(
      String(valueDiscountStr).replace(/[^0-9.-]+/g, '')
    );

    if (typeDiscount === IOfferDiscountTypeName.PERCENTAGE) {
      res = valueOffer - (valueOffer * valueDiscount) / 100;
    } else {
      res = valueOffer - valueDiscount;
    }
    return res > 0 ? res.toFixed(2) : 'Free';
  }
}
